import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from '@env/environment';
import { UserStore } from '@stores/user.store';
import { MsalAngularService } from '@services/msal-angular.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    private acquireTokenCalled = false; // track if refreshToken call has been made

    constructor(private msalAngularService: MsalAngularService, private userService: UserStore) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const url: string = request.url;

        if (!url.startsWith(environment.baseUrl)) {
            return next.handle(request);
        }

        request = this.getHeaderToken(request);

        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                    if (this.acquireTokenCalled) {
                        // this.us.logout();
                        this.acquireTokenCalled = false;
                        return throwError(() => error);
                    }

                    this.acquireTokenCalled = true;
                    return from(this.msalAngularService.acquireTokenSilent()).pipe(
                        switchMap((success: boolean) => {
                            if (success) {
                                this.acquireTokenCalled = false;
                                request = this.getHeaderToken(request);
                                return next.handle(request);
                            } else {
                                // this.appNavigationService.logout();
                                return throwError(() => error);
                            }
                        }),
                    );
                }

                return throwError(() => error);
            }),
        );
    }

    private getHeaderToken(request: HttpRequest<unknown>): HttpRequest<unknown> {
        return request.clone({
            setHeaders: {
                Authorization: 'Bearer ' + this.userService.getUser().token,
            },
        });
    }
}
